import React from "react";
import PropTypes from "prop-types";

import IconGrid from "icons/IconGrid";
import SkeletonIconGrid from "icons/SkeletonIconGrid";
import BrowseAllContentCTA from "./BrowseAllContentCTA";
import BrowseAllContentTextLink from "./BrowseAllContentTextLink";
import SearchIcons from "./SearchIcons";
import Heading from "core/Heading";

import { NUMBER_OF_ICONS_IN_GRID } from "./CreatorProfileIconsPage";
import { BROWSE_ICONS_BY_CREATOR } from "data/links";

import { SearchAndLinkContainer } from "./styles";

import breakpoints from "core/breakpoints";

import { useViewport } from "js/hooks/useViewport";
import { convertPxToRem } from "frontend/components/helpers";

const IconsSection = ({ loading, icons, totalCount, username }) => {
    const { browserWidth } = useViewport();
    const onDesktop = browserWidth >= breakpoints.desktop.px;
    const onTablet =
        browserWidth < breakpoints.desktop.px &&
        browserWidth >= breakpoints.tablet.px;
    const onMobile = browserWidth < breakpoints.tablet.px;

    let numberOfColumns;
    let gridSpacingSize;

    if (onDesktop || onTablet) {
        numberOfColumns = 5;
        gridSpacingSize = convertPxToRem({ px: 24 });
    }

    if (onMobile) {
        numberOfColumns = 2;
        gridSpacingSize = convertPxToRem({ px: 16 });
    }

    if (totalCount === 0) return null;

    const grid = loading ? (
        <SkeletonIconGrid
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
            numberOfItems={NUMBER_OF_ICONS_IN_GRID}
        />
    ) : (
        <IconGrid
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
            iconData={icons}
        />
    );

    const browseAllProps = {
        contentCount: totalCount || 0,
        contentType: "icon",
        username,
        href: BROWSE_ICONS_BY_CREATOR.replace(":username", username)
    };

    return (
        <section>
            <SearchIcons username={username} />
            <SearchAndLinkContainer>
                <Heading size="sm">Icons</Heading>
                <BrowseAllContentTextLink {...browseAllProps} />
            </SearchAndLinkContainer>
            {grid}
            <BrowseAllContentCTA {...browseAllProps} />
        </section>
    );
};

IconsSection.propTypes = {
    loading: PropTypes.bool,
    icons: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired
};

export default IconsSection;
